import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Common_en from './locales/en/Common.json';
import LedStatus_en from './locales/en/LedStatus.json'; 
import DeviceSettings_en from './locales/en/DeviceSettings.json';
import DetectionSettings_en from './locales/en/DetectionSettings.json';
import EmailSettings_en from './locales/en/EmailSettings.json';
import SnmpSettings_en from './locales/en/SnmpSettings.json';
import AuditLogs_en from './locales/en/AuditLogs.json';
import DebugLogs_en from './locales/en/DebugLogs.json';
import Menu_en from './locales/en/Menu.json';


import Common_ja from './locales/ja/Common.json';
import LedStatus_ja from './locales/ja/LedStatus.json';
import DeviceSettings_ja from './locales/ja/DeviceSettings.json';
import DetectionSettings_ja from './locales/ja/DetectionSettings.json';
import EmailSettings_ja from './locales/ja/EmailSettings.json';
import SnmpSettings_ja from './locales/ja/SnmpSettings.json';
import AuditLogs_ja from './locales/ja/AuditLogs.json';
import DebugLogs_ja from './locales/ja/DebugLogs.json';

import Menu_ja from './locales/ja/Menu.json';

const resources = {
  en: {
    Common: Common_en,
    LedStatus: LedStatus_en,
    DeviceSettings: DeviceSettings_en,
    DetectionSettings: DetectionSettings_en,
    EmailSettings: EmailSettings_en,
    SnmpSettings: SnmpSettings_en,
    AuditLogs: AuditLogs_en,
    DebugLogs : DebugLogs_en,
    Menu: Menu_en
  },
  ja: {
    Common: Common_ja,
    LedStatus: LedStatus_ja,
    DeviceSettings: DeviceSettings_ja,
    DetectionSettings: DetectionSettings_ja,
    EmailSettings: EmailSettings_ja,
    SnmpSettings: SnmpSettings_ja,
    AuditLogs: AuditLogs_ja,
    DebugLogs : DebugLogs_ja,
    Menu: Menu_ja
  },
};

i18n.use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ja',
    lng: localStorage.getItem('language') || navigator.language,
    interpolation: {
      escapeValue: false,
    },
    defaultNS: 'Common',
    ns: ['Common', 'LedStatus', 'DeviceSettings', 'DetectionSettings', 'EmailSettings', 'SnmpSettings', 'AuditLogs', 'Menu'],
  });

export default i18n;